let authToken = null;
let authUser = null;

const clearLegacyAuthStorageKeys = () => {
    try {
        localStorage.removeItem("pbx_auth_user");
        localStorage.removeItem("pbx_auth_token");
    } catch {
        // Ignore storage access failures (private mode, blocked storage, etc.).
}
};

export const setAuthSession = ({ token, user } = {}) => {
    authToken = token || null;
    authUser = user || null;
    clearLegacyAuthStorageKeys();
};

export const clearAuthSession = () => {
    authToken = null;
    authUser = null;
    clearLegacyAuthStorageKeys();
};

const parsePersistedRoot = () => {
    try {
        const rawRoot = localStorage.getItem("persist:root");
        if (!rawRoot) return null;

        const parsedRoot = JSON.parse(rawRoot);
        if (!parsedRoot?.auth) return null;

        const parsedAuth = JSON.parse(parsedRoot.auth);
        const session = parsedAuth?.session;
        if (!session) return null;

        return {
            token: session.token || null,
            user: session.user || null,
        };
    } catch {
        return null;
    }
};

export const getPersistedAuthToken = () => {
    if (authToken) return authToken;
    const persisted = parsePersistedRoot();
    return persisted?.token || null;
};

export const getPersistedAuthUser = () => {
    if (authUser) return authUser;
    const persisted = parsePersistedRoot();
    return persisted?.user || null;
}